exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".translation-source[data-v-fbee39ac]{white-space:pre-wrap}", ""]);

// exports
